import index from "../index/en.js"
import login from "../login/de.js"
import projectList from "../projectList/de.js"
import post from "../post/de.js"
import admin from "../admin/de.js"

export default {
  index,
  login,
  projectList,
  post,
  admin
}



// WEBPACK FOOTER //
// ./src/locale/lang/de.js